export const sampleArtwork = [
  {
    ObjectID: 1,
    aic_id: 59846,
    title: "Woman's Head with Roses",
    artist_title: "Koloman (Kolo) Moser",
    place_of_origin: "Austria",
    date_start: 1899,
    date_display: "1899",
    thumbnailUrl: "https://www.artic.edu/iiif/2/b985fa1c-cac3-a979-9ffe-28ffb8e921c2",
    classification_title: "Stencil",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/59846",
    is_public_domain: "true",
    latitude: 47.585810005,
    longitude: 14.1370769480001
  },
  {
    ObjectID: 2,
    aic_id: 49409,
    title: "Portrait of Félicien Rops",
    artist_title: "Adrien Lambert Jean de Witte",
    place_of_origin: "Belgium",
    date_start: 1890,
    date_display: "c. 1895",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/ea9cc3de-371c-e372-f720-996df6d20f1c",
    classification_title: "Etching",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/49409",
    is_public_domain: "true",
    latitude: 50.6406829370001,
    longitude: 4.66107042700003,
  },
  {
    ObjectID: 3,
    aic_id: 656,
    title: "Lion (One of a Pair, South Pedestal)",
    artist_title: "Edward Kemeys",
    place_of_origin: "Chicago",
    date_start: 1893,
    date_display: "1893",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/c2550f00-20d6-6a95-b798-f395c1ff02eb",
    classification_title: "Sculpture",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/656",
    is_public_domain: "false",
    latitude: 41.881832,
    longitude: -87.623177,
  },
  {
    ObjectID: 4,
    aic_id: 217685,
    title:
      "Landscape and Figure, from an album of Landscapes and Calligraphy for Liu Songfu",
    artist_title: "Xugu",
    place_of_origin: "China",
    date_start: 1895,
    date_display: "Qing dynasty (1644–1911), 1895/96",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/314a5c9e-f7f7-cd43-2255-b0d69f96931e",
    classification_title: "Painting",
    style_title: "Chinese (culture or style)",
    api_link: "https://api.artic.edu/api/v1/artworks/217685",
    is_public_domain: "true",
    latitude: 35.86166,
    longitude: 104.1953964,
  },
  {
    ObjectID: 5,
    aic_id: 113265,
    title: "Merganser",
    artist_title: "John Ruskin",
    place_of_origin: "England",
    date_start: 1890,
    date_display: "February 29, 1890",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/43c6fc44-6dc8-f053-41d8-df3057eb6857",
    classification_title: "Watercolor",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/113265",
    is_public_domain: "true",
    latitude: 52.355518,
    longitude: -1.17432,
  },
  {
    ObjectID: 6,
    aic_id: 215581,
    title: "Ely Cathedral: South Aisle to East, from Southwest Transept",
    artist_title: "Frederick H. Evans",
    place_of_origin: "England",
    date_start: 1891,
    date_display: "1891",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/bde84445-a636-0c76-8c0b-e7b384ca7aff",
    classification_title: "Photograph",
    style_title: "Pictorialism",
    api_link: "https://api.artic.edu/api/v1/artworks/215581",
    is_public_domain: "true",
    latitude: 52.355518,
    longitude: -1.17432,
  },
  {
    ObjectID: 7,
    aic_id: 42634,
    title: "Woman with Elaborate Coiffure",
    artist_title: "Imitator of Aubrey Vincent Beardsley",
    place_of_origin: "England",
    date_start: 1892,
    date_display: "1892/98",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/c2873c48-4d38-9f4b-a249-43dfe6f85b7e",
    classification_title: "Pen and ink drawings",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/42634",
    is_public_domain: "true",
    latitude: 52.355518,
    longitude: -1.17432,
  },
  {
    ObjectID: 8,
    aic_id: 41036,
    title:
      "Study for How a Devil in Woman's Likeness Would Have Tempted Sir Bors",
    artist_title: "Aubrey Vincent Beardsley",
    place_of_origin: "England",
    date_start: 1893,
    date_display: "1893",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/654adc3f-18b1-6197-5996-5828e7b186d8",
    classification_title: "Pen and ink drawings",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/41036",
    is_public_domain: "true",
    latitude: 52.355518,
    longitude: -1.17432,
  },
  {
    ObjectID: 9,
    aic_id: 55814,
    title: "At the Moulin Rouge, La Goulue and Her Sister",
    artist_title: "Henri de Toulouse-Lautrec",
    place_of_origin: "France",
    date_start: 1892,
    date_display: "1892",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/084ad823-ab84-23c2-672a-51fb1a2809ce",
    classification_title: "Lithograph",
    style_title: "Post-Impressionism",
    api_link: "https://api.artic.edu/api/v1/artworks/55814",
    is_public_domain: "true",
    latitude: 46.227638,
    longitude: 2.213749,
  },
  {
    ObjectID: 10,
    aic_id: 106626,
    title: "Light",
    artist_title: "Odilon Redon",
    place_of_origin: "France",
    date_start: 1893,
    date_display: "1893",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/32d0ffa0-460e-ff57-f978-353e4d472075",
    classification_title: "Lithograph",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/106626",
    is_public_domain: "true",
    latitude: 46.227638,
    longitude: 2.213749,
  },
  {
    ObjectID: 11,
    aic_id: 159089,
    title: "Tahitian Idol—the Goddess Hina",
    artist_title: "Paul Gauguin",
    place_of_origin: "France",
    date_start: 1894,
    date_display: "1894/95",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/d64e058a-3124-5947-0635-7a759f3b500b",
    classification_title: "Woodcut",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/159089",
    is_public_domain: "true",
    latitude: 46.227638,
    longitude: 2.213749,
  },
  {
    ObjectID: 12,
    aic_id: 25832,
    title: "Jean Renoir Sewing",
    artist_title: "Pierre-Auguste Renoir",
    place_of_origin: "France",
    date_start: 1899,
    date_display: "1899/1900",
    thumbnailUrl: "https://www.artic.edu/iiif/2/a9675660-f0c7-ab02-b459-eb365e62dd8b",
    classification_title: "Oil On Canvas",
    style_title: "Impressionism",
    api_link: "https://api.artic.edu/api/v1/artworks/25832",
    is_public_domain: "true",
    latitude: 46.227638,
    longitude: 2.213749
  },
  {
    ObjectID: 13,
    aic_id: 241924,
    title: "Head of a Bearded Man in Half-Profile",
    artist_title: "Adolph Friedrich Erdmann von Menzel",
    place_of_origin: "Germany",
    date_start: 1894,
    date_display: "1894",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/d82af8ff-2f1b-1dfb-c956-d6f91e0a11c9",
    classification_title: "Graphite",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/241924",
    is_public_domain: "true",
    latitude: 51.165691,
    longitude: 10.451526,
  },
  {
    ObjectID: 14,
    aic_id: 46181,
    title: "Two carved wooden transoms (ramma) panels from the Hooden",
    artist_title: "Takamura Kôun",
    place_of_origin: "Japan",
    date_start: 1893,
    date_display: "1893",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/fda5f63b-a20a-962a-bacf-02d1f8e7c106",
    classification_title: "Wood",
    style_title: "Japanese (Culture Or Style)",
    api_link: "https://api.artic.edu/api/v1/artworks/46181",
    is_public_domain: "true",
    latitude: 36.6552269980001,
    longitude: 139.271495,
  },
  {
    ObjectID: 15,
    aic_id: 154963,
    title:
      'Takasago, from the series "Pictures of No Performances (Nogaku Zue)"',
    artist_title: "Tsukioka Kôgyo",
    place_of_origin: "Japan",
    date_start: 1893,
    date_display: "1898",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/41400931-6afb-a123-6916-c4c13843fad4",
    classification_title: "Woodblock print",
    style_title: "Japanese (culture or style)",
    api_link: "https://api.artic.edu/api/v1/artworks/154963",
    is_public_domain: "true",
    latitude: 36.6552269980001,
    longitude: 139.271495,
  },

  {
    ObjectID: 16,
    aic_id: 37733,
    title: "Garden rug",
    artist_title: "Unknown Artist",
    place_of_origin: "Kazakhstan",
    date_start: 1890,
    date_display: "1890",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/45faff9c-479c-3219-ec6f-20eb5dcfd324",
    classification_title: "Textile",
    style_title: "Kazak",
    api_link: "https://api.artic.edu/api/v1/artworks/37733",
    is_public_domain: "true",
    latitude: 51.166667,
    longitude: 71.433333,
  },
  {
    ObjectID: 17,
    aic_id: 49639,
    title: "Pachuquenian Calavera",
    artist_title: "José Guadalupe Posada",
    place_of_origin: "México",
    date_start: 1894,
    date_display: "1894",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/d0257899-fab3-7b7f-ea0f-832fd6bb29d8",
    classification_title: "Lithograph",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/49639",
    is_public_domain: null,
    latitude: 23.9528249900001,
    longitude: -102.548353419,
  },
  {
    ObjectID: 18,
    aic_id: 17226,
    title: "Summernight. The Voice",
    artist_title: "Edvard Munch",
    place_of_origin: "Norway",
    date_start: 1894,
    date_display: "1894",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/b3203fef-8b36-50b6-9769-8d1262064f11",
    classification_title: "Aquatint",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/17226",
    is_public_domain: null,
    latitude: 60.472023,
    longitude: 8.468946,
  },
  {
    ObjectID: 19,
    aic_id: 41293,
    title: "The Gargoyles, Stirling Castle",
    artist_title: "David Young Cameron",
    place_of_origin: "Scotland",
    date_start: 1898,
    date_display: "1898",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/4eca1704-310f-1c56-7b5d-8f7b959b88bc",
    classification_title: "Etching",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/41293",
    is_public_domain: "true",
    latitude: 56.4906712,
    longitude: -4.2026458,
  },
  {
    ObjectID: 20,
    aic_id: 16473,
    title: "Cigar Making in Seville",
    artist_title: "Ricardo Canals y Llambí",
    place_of_origin: "Seville",
    date_start: 1899,
    date_display: "1899",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/3d232049-27d2-a048-413a-2f01ab0b0fc8",
    classification_title: "Painting",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/16473",
    is_public_domain: "true",
    latitude: 37.3878800000001,
    longitude: -6.00195999999994,
  },
  {
    ObjectID: 21,
    aic_id: 73443,
    title: "Flower Pot with Stand",
    artist_title: "Unknown Artist",
    place_of_origin: "Strasburg",
    date_start: 1890,
    date_display: "1890/1900",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/e5c34743-e72c-ade7-0021-afdcd2f7f201",
    classification_title: "Cachepot",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/73443",
    is_public_domain: "true",
    latitude: 48.58504,
    longitude: 7.73642000000007,
  },
  {
    ObjectID: 22,
    aic_id: 41834,
    title: "Grover Cleveland II",
    artist_title: "Anders Zorn",
    place_of_origin: "Sweden",
    date_start: 1899,
    date_display: "1899",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/a14fe0a6-9e6a-37da-2564-326ccaa972eb",
    classification_title: "Etching",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/41834",
    is_public_domain: "true",
    latitude: 62.3875,
    longitude: 16.325556,
  },
  {
    ObjectID: 23,
    aic_id: 48117,
    title: "Handkerchief",
    artist_title: "Unknown Artist",
    place_of_origin: "Switzerland",
    date_start: 1892,
    date_display: "1892/1900",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/8013a29e-cc2e-0dd2-8ca9-6d9d94ab1496",
    classification_title: "Textile",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/48117",
    is_public_domain: null,
    latitude: 46.7998174420001,
    longitude: 8.24502409600007,
  },
  {
    ObjectID: 25,
    aic_id: 103545,
    title: "Spinning",
    artist_title: "Emilie V. Clarkson",
    place_of_origin: "United States",
    date_start: 1894,
    date_display: "c. 1898",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/e735d4ba-f01f-fdfb-f9de-05807513b54f",
    classification_title: "Photogravure",
    style_title: "19th century",
    api_link: "https://api.artic.edu/api/v1/artworks/103545",
    is_public_domain: "true",
    latitude: 37.09024,
    longitude: -95.712891,
  },
  {
    ObjectID: 25,
    aic_id: 158244,
    title: "The Vow of Vengeance",
    artist_title: "Hermon Atkins MacNeil",
    place_of_origin: "United States",
    date_start: 1894,
    date_display: "1894",
    thumbnailUrl:
      "https://www.artic.edu/iiif/2/1eb7de13-7418-6785-e9a9-2116288454a5",
    classification_title: "Sculpture",
    style_title: null,
    api_link: "https://api.artic.edu/api/v1/artworks/158244",
    is_public_domain: "true",
    latitude: 37.09024,
    longitude: -95.712891,
  },
];
